import type { ReactNode } from "react";

import ScorecardSectionHeader from "./ScorecardSectionHeader";
import ScorecardSectionIntro from "./ScorecardSectionIntro";

import { cn } from "@/lib/utils";

interface ScorecardSectionBlockHeaderProps {
  label: string;
  description?: ReactNode;
  action?: ReactNode;
  className?: string;
  headerClassName?: string;
  descriptionClassName?: string;
}

const ScorecardSectionBlockHeader = ({
  label,
  description,
  action,
  className,
  headerClassName,
  descriptionClassName,
}: ScorecardSectionBlockHeaderProps) => (
  <div className={cn("space-y-1 px-0.5", className)}>
    <ScorecardSectionHeader label={label} action={action} className={headerClassName} />
    {description ? (
      <ScorecardSectionIntro className={descriptionClassName}>{description}</ScorecardSectionIntro>
    ) : null}
  </div>
);

export default ScorecardSectionBlockHeader;
